import React from 'react'

const DocLabel =(props)=>{
    const {formObject, viewData} = props

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    const valCssStyle = formObject.getValueFromKey(viewData, "dataList.valCssStyle", ""); 
    
    let cssStyle = valCssStyle ? JSON.parse(valCssStyle) : {};

    if (viewData?.dataList?.colCssStyle) console.log("style", viewData?.dataList?.colCssStyle, cssStyle, valCssStyle)

    return (
        <div className="saras-cell">
            <div className={valCssClass} style={cssStyle}> 
                {viewData.valF}
            </div>
        </div>
    )
}

export default DocLabel
